import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { base_url } from "../apiConfig";

export function useFetchQueTypes(url, dependencies) {

  dependencies = Array.isArray(dependencies) ? dependencies : [];

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getApiData(url);
  }, [url, ...dependencies]);
  const getApiData = async (url) => {
    setIsLoading(true);
    try {
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/`;
      const token = localStorage.getItem("authToken");

      const response = await axios.get(fullUrl + url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      setData(response.data);
    } catch (error) {
      console.log("An error occurred while fetching the API:", error);
      setError(error.response?.statusText || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, setData, isLoading, setIsLoading, error };
}

export function useFetchQueDataList(url, dependencies = []) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getApiData(url);
  }, [url, ...dependencies]);

  const getApiData = async (url) => {
    setIsLoading(true);
    try {
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/`;
      const token = localStorage.getItem("authToken");

      const response = await axios.get(fullUrl + url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      setData(response.data);
    } catch (error) {
      console.log("An error occurred while fetching the API:", error);
      setError(error.response?.statusText || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, setData, isLoading, error };
}

export function useFetchAudCycles(url, dependencies = []) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getApiData(url);
  }, [url, ...dependencies]);

  const getApiData = async (url) => {
    setIsLoading(true);
    try {
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/`;
      const token = localStorage.getItem("authToken");

      const response = await axios.get(fullUrl + url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      setData(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.log("An error occurred while fetching the API:", error);
      setError(error.response?.statusText || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, setData, isLoading, error };
}

export function useGetAiInsights() {
  const [data, setData] = useState([]);
  const [secondApiData, setSecondApiData] = useState([]);
  const [npsSoreApiData, setNpsSoreApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getApiData = async (url) => {
    setIsLoading(true);
    try {
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}${url}`;
      const token = localStorage.getItem("authToken");
      const response = await axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      // console.log("First API response data from hook:", response.data);
      setData(response.data);

      if (response.data?.audit_cycle?.length > 0) {
        const firstAuditCycleId = response.data.audit_cycle[0]?.id;
        localStorage.setItem("selectedAuditId", firstAuditCycleId);

        await getSecondApi(firstAuditCycleId);
        await getNpsScoreThirdApi(firstAuditCycleId);
      }
    } catch (error) {
      console.log("An error occurred while fetching the API:", error);
      setError(error.response?.statusText || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getSecondApi = async (auditId) => {
    try {
      const secondApiUrl = `client/summary/audit_report/${auditId}`;
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}${secondApiUrl}`;
      const token = localStorage.getItem("authToken");

      const response = await axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      setSecondApiData(response.data);
      // console.log("Second API Data from hook:", response.data);
    } catch (error) {
      console.log("An error occurred while fetching the second API:", error);
    }
  };

  const getNpsScoreThirdApi = async (auditId) => {
    try {
      const npsScoreApiUrl = `client/over_all_summary/audit_cycle/${auditId}`;
      const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}${npsScoreApiUrl}`;
      const token = localStorage.getItem("authToken");

      const response = await axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      setNpsSoreApiData(response.data);
      // console.log("Third API Data from hook:", response.data);
    } catch (error) {
      console.log("An error occurred while fetching the third API:", error);
    }
  };
  return {
    data,
    secondApiData,
    npsSoreApiData,
    isLoading,
    setIsLoading,
    error,
    getApiData,
    getSecondApi,
    getNpsScoreThirdApi,
  };
}

// ===================================================================
export const useFetchFunction = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  const abortControllerRef = useRef(null);

  const getBaseUrl = () => {
    const port = base_url.port ? `:${base_url.port}` : "";
    return `${base_url.protocol}://${base_url.hostname}${port}${base_url.api_base_path}`;
  };

  const getData = async (url, payload = null) => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      console.log("Token doesn't exist!");
      setError("Token doesn't exist!");

      return {
        success: false,
        data: [],
        error: "Token doesn't exist!",
      };
    }

    // Cancel previous request made by THIS hook instance
    abortControllerRef.current?.abort();

    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoading(true);
    setError(null);

    try {
      const apiUrl = `${getBaseUrl()}client/${url}`;

      const options = {
        method: payload ? "POST" : "GET",
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "application/json",
        },
        signal: controller.signal,
      };

      if (payload) {
        options.body = JSON.stringify(payload);
      }

      const response = await fetch(apiUrl, options);
      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result?.detail ||
          result?.message ||
          "Something went wrong"
        );
      }

      // Only update state if this request wasn't cancelled
      if (!controller.signal.aborted) {
        setData(result);
      }

      return {
        success: true,
        data: result,
      };

    } catch (err) {

      // Don't treat cancellation as an API error
      if (err.name === "AbortError") {
        return {
          success: false,
          aborted: true,
          data: [],
        };
      }

      console.error("API Error:", err);

      setError(err);
      setData([]);

      return {
        success: false,
        data: [],
        error: err,
      };

    } finally {

      // Don't turn loading off if another request has already started
      if (!controller.signal.aborted) {
        setLoading(false);
      }
    }
  };

  return {
    loading,
    data,
    setData,
    getData,
    error,
  };
};